<template>
  <div>
    <hi-dialog
      title="Edit Email Address"
      ref="dialog"
      v-model="isOpen"
      :submit-disabled="!valid"
      @submit="submit"
      :error="error"
    >
      <v-form v-model="valid">
        <v-text-field
          v-model="email"
          :rules="emailRules"
          label="Email"
          ref="input"
        >
        </v-text-field>
      </v-form>
    </hi-dialog>
  </div>
</template>

<script>
import HiDialog from "@/components/HiDialog";
// import HiSimpleInput from "@/components/HiSimpleInput";
import Validator from "@/hive/Validator";
import { DocHelper } from "@/db";
export default {
  name: "DiEmailEditor",
  components: { HiDialog },
  props: {
    collectionPath: {
      type: String,
      required: true
    },
    docPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      // emailValidator: Validator.email,
      email: null,
      emailRules: [v => Validator.email(v) || "Email must be valid"],
      valid: false,
      error: null
    };
  },
  methods: {
    open(val) {
      this.isOpen = true;
      this.email = val;
      setTimeout(() => this.$refs.input.focus(), 100);
    },
    async submit() {
      try {
        const helper = new DocHelper(this.collectionPath, this.docPath, true);
        await helper.update("email", this.email);

        this.isOpen = false;
      } catch (e) {
        this.error = e.message;
      }
    }
  }
};
</script>

<style scoped></style>
